import { useMemo } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import { ROUTES } from '../routes'
import { useAreaStore, useGetAreas } from '@/modules/Areas'
import { useWorkstationStore } from '@/modules/Workstation/store'

export const usePMNavigation = () => {
    const location = useLocation()
    const navigate = useNavigate()
    const { data: areas } = useGetAreas()
    const { workstation } = useWorkstationStore()
    const { selectedAreaCode } = useAreaStore()
    const selectedArea = areas?.find((area) => area.code === selectedAreaCode)

    const backCallback = useMemo(() => {
        if (location.pathname === ROUTES.HOME) {
            return () => navigate(ROUTES.AREAS)
        }

        if ([ROUTES.SHARED_LOG].includes(location.pathname)) {
            return () => navigate(ROUTES.UNFINISHED_RECORDS)
        }

        if ([ROUTES.DISRUPTIONS, ROUTES.VEHICLE_ALLOCATION, ROUTES.SHARED_LOG].includes(location.pathname)) {
            return () => navigate(ROUTES.HOME)
        }
    }, [location, navigate])

    const paths = useMemo(() => {
        if (location.pathname === ROUTES.HOME) {
            return [selectedArea?.title ?? 'All areas', workstation?.workstationNumber]
        }

        if (location.pathname === ROUTES.SHARED_LOG) {
            return [selectedArea?.title ?? 'All areas', workstation?.workstationNumber]
        }

        if (workstation && location.pathname === ROUTES.SHARED_LOG) {
            return ['Controller logs', workstation.workstationNumber]
        }

        if (workstation && location.pathname === ROUTES.DISRUPTIONS) {
            return [selectedArea?.title ?? 'All areas', workstation.workstationNumber, 'Disruptions']
        }

        if (workstation && location.pathname === ROUTES.VEHICLE_ALLOCATION) {
            return [selectedArea?.title ?? 'All areas', workstation.workstationNumber, 'Vehicle allocation']
        }

        if (location.pathname === ROUTES.FLAGGED) {
            return [selectedArea?.title ?? 'All areas', 'Flagged records']
        }

        return []
    }, [location, workstation, selectedArea?.title])

    return {
        backCallback,
        paths,
    }
}
